import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LesseeSelection } from '@app/ps/models/lessee.model';
import { ProjectSubjectModel } from '@app/ps/models/project-subject.model';
import { LesseeService } from '@app/ps/services/lessee.service';

@Component({
  selector: 'gmt-case-lessee',
  templateUrl: './case-lessee.component.html',
})
export class CaseLesseeComponent {
  @Input() caseId: number;
  @Input() lessee: ProjectSubjectModel;
  @Input() locked = false;
  @Output() lesseeChange = new EventEmitter<ProjectSubjectModel | undefined>();

  editing = false;
  selection: LesseeSelection = {};

  constructor(
    private lesseeService: LesseeService,
  ) {
    this.save = this.save.bind(this);
  }

  edit() {
    if (this.locked) {
      return;
    }
    this.selection = { lessee: this.lessee };
    this.editing = true;
  }

  cancel() {
    this.editing = false;
  }

  // existujícího pachtýře nelze odebrat, pouze změnit
  canSave(): boolean {
    return !this.lessee || !!this.selection.lessee || !!this.selection.lpis;
  }

  async save() {
    if (!this.canSave()) {
      return;
    }
    const lessee = await this.lesseeService.resolveSelection(this.selection);
    const saved = await this.lesseeService.updateCaseLessee(this.caseId, lessee);
    this.editing = false;
    this.lesseeChange.emit(saved);
  }
}
